import ProfileDetailUserDataSubAccounts from './ProfileDetailUserDataSubAccounts';

export type TViewMode = 'compact' | 'detailed';

export default ProfileDetailUserDataSubAccounts;
